export const setAccount = (u, account) => {
    u('currentAccount', () => account);
};
export const clearAccount = (u) => {
    u('currentAccount', () => ({ address: '', ens: '' }));
};
